import React from 'react'
import PropTypes from 'prop-types';

import { List } from '@leverege/ui-elements'

import style from './style.css'
import ListModal from '../../views/ListModal';

const num = 0;

export default class BlueprintDialogSelector extends React.Component {

  static contextTypes = {
    api : PropTypes.object
  }

  static propTypes = {
    onItemSelected : PropTypes.func,
    projectId : PropTypes.string.isRequired,
    path : PropTypes.string,
    flagName : PropTypes.string,
    showFlag : PropTypes.bool,
    initialFlag : PropTypes.bool
  }

  constructor( props ) {
    super( props )
    this.state = { blueprints : [],
                   loading : true,
                   error : null, 
                   flag : props.initialFlag == null ? true : props.initialFlag }
  }

  onItemSelected = ( { data } ) => {
    const { onClose, onItemSelected } = this.props
    if ( onItemSelected ) {
      onItemSelected( data, this.state.flag )
    }

    onClose()

    return false
  }

  componentWillMount( ) {
    const { api } = this.context
    const { projectId } = this.props
    this.mounted = true
    if ( api && projectId ) {
      api.getBlueprints( projectId ).then( ( result ) => {
        if ( this.mounted ) {
          this.setState( { blueprints : result.items, loading : false } )
        }
      } ).catch( ( ex ) => {
        if ( this.mounted ) {
          this.setState( { error : ex, loading : true } )
        }
      } )
    }
  }

  componentWillUnmount() {
    this.mounted = false
  }

  render() {
    const { blueprints, flag } = this.state
    const { message, onClose, show, showFlag, flagName } = this.props

    const mtypes = blueprints.map( ( item, index ) => {
      return (
        <List.Item
          className={style.listItem}
          key={item.id}
          item={item}>
          {item.name}
        </List.Item>
      ) 
    } );

    return (
      <ListModal
        mtypes={mtypes}
        message={message}
        onClose={onClose}
        show={show}
        showFlag={showFlag}
        flagName={flagName}
        flag={flag}
        title="Blueprints"
        onClick={this.onItemSelected}
        onFlag={( { value } ) => { this.setState( { flag : value } ) }} />
    )
  }
}
